export const aiSummaryData = {
  progress: 75,
  processed: 3,
  total: 4,
  keyDataPoints: {
    revenue: "$12.5M",
    employees: 85,
    legalEntity: "Delaware Corp",
  },
  missingDocuments: ["Cap Table", "Insurance Policies", "Customer Contracts"],
};
